import {useIntl} from 'react-intl';
import {useMatrixContext} from '../../../providers/MatrixProvider';
import {groupCallMessages as m} from '../messages';

export const useGroupCallRoomName = (roomId: string | null | undefined): string => {
    const intl = useIntl();
    const {rooms} = useMatrixContext();
    return rooms.find(room => room.roomId === roomId)?.name || intl.formatMessage(m.historyUnknownRoom);
};
